import {Box, Divider, IconButton, List, ListSubheader, Stack, Tooltip, Button} from "@mui/material";
import {AddOutlined, LibraryBooksOutlined} from "@mui/icons-material";
import CaseListItem from "./CaseListItem";
import SearchBar from "../SearchBar";
import {useRef, useState, MutableRefObject, useEffect} from "react";
import {useParams, useRouter} from "next/navigation";
import {useTranslation} from "react-i18next";
import {navMap} from "../../../../nav/navMap";
import {useCases} from "../../context/CasesContext";
import {Case} from "../../legal/newCase/form/newCaseForm";
import {useTheme} from '@mui/material';

export default function CasesList({setOpen}) {
    const router = useRouter();
    const {casesList, handleSelectCase, selectedCase} = useCases();
    const [filteredCases, setFilteredCases] = useState<Case[]>([]);
    const searchRef: MutableRefObject<any> = useRef(null);
    const params = useParams();
    const theme = useTheme();

    const {t, i18n} = useTranslation();
    const currentLocale = i18n.language;

    const navToNewCaseCreator = () => {
        router.push(navMap.locale(currentLocale).newCase());
        setOpen(false);
    };

    const pushSearchResult = async (searchResult) => {
        setFilteredCases(searchResult);
    };

    const toMainMenu = () => {
        router.push(navMap.locale(currentLocale).legal());
    };

    const navToCase = (selectedCase: Case) => {
        setOpen(false);
        router.push(navMap.locale(currentLocale).caseId(selectedCase.id).menu());
        searchRef?.current?.clearSearch();
        handleSelectCase(selectedCase);
    };

    useEffect(() => {
        setFilteredCases(casesList);
    }, [casesList]);

    useEffect(() => {
        if(params?.caseId && !selectedCase) {
            const selectParamCase = casesList.find(caseItem => {
                return caseItem.id == params.caseId;
            });
            if(selectParamCase) handleSelectCase(selectParamCase);
        }
    }, [params, casesList]);

    return (
        <Box sx={{ height: "100%", backgroundColor: "primary.main" }}>
            <List
                sx={{
                    justifyContent: "flex-end",
                    alignItems: "center",
                    height: "100%",
                }}
                subheader={
                    <ListSubheader
                        component="div"
                        sx={{backgroundColor: "primary.main"}}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                minHeight: "64px",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "18vw",
                                minWidth: "250px",
                            }}
                        >
                            <Tooltip title={t("back-main-page")}>
                                <Button onClick={toMainMenu}>
                                    <img
                                        src={theme.logo}
                                        alt="Logo AI4Legal"
                                        height={40}
                                        style={{padding: "4px"}}
                                    />
                                </Button>
                            </Tooltip>
                            <Stack direction="row">
                                <Tooltip title={t("common:cases.change-case")}>
                                    <IconButton onClick={() => setOpen(false)}>
                                        <LibraryBooksOutlined />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={t("common:cases.new-case")}>
                                    <IconButton onClick={navToNewCaseCreator}>
                                        <AddOutlined />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </Box>
                        <Divider />
                        <SearchBar ref={searchRef} pushSearchResult={pushSearchResult} />
                        <Divider sx={{m: 2}} />
                    </ListSubheader>
                }
            >
                {filteredCases?.length > 0 &&
                    filteredCases?.map((caseItem: Case, index: number) => (
                        <CaseListItem
                            key={index}
                            caseItem={caseItem}
                            navToCase={navToCase}
                        />
                    ))}
            </List>
        </Box>
    );
}